export { default as FilledStarIcon } from './FilledStarIcon';
